import React from "react";

export const NodeContent = ({children, fontColor}) => {
  return (
    <div style={{ padding: 10, color: fontColor, maxWidth: 200 }} dangerouslySetInnerHTML={{__html: children}}></div>
  )
}
